import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { grey } from '@mui/material/colors';
import { COLORS } from 'shared/constants/AppEnums';
import DialogModal from 'shared/components/DialogModal';
import { Checkbox, DialogActions, FormControlLabel, FormGroup, IconButton, InputAdornment, InputLabel, Stack, TextField, Typography } from '@mui/material';
import { ButtonContained, ButtonOutlined } from 'shared/components/Button';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useAuthUser } from '@crema/utility/AuthHooks';

const DialogSignDetail = ({ open, state, title, error, onChangeState, handleClose, handleSubmit, bypass = true }) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const { user } = useAuthUser()
    const isBypass = user.roles_coofis.some(item => item.state === 'BYPASS_PASSPHRASE')

    return (
        <DialogModal open={open} title={title} handleClose={handleClose}>
            <Stack
                direction={'column'}
                spacing={2}
                sx={{
                    // marginTop: '1rem',
                    // marginBottom: '2.5rem',
                    '& label.Mui-focused': {
                        color: COLORS.primary,
                    },
                    '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': {
                            borderColor: grey[500],
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: COLORS.primary,
                            color: COLORS.primary
                        },
                    },
                }}
            >
                <TextField
                    value={state.passphrase}
                    error={error.passphrase}
                    fullWidth
                    name='passphrase'
                    id="outlined-basic"
                    label="Masukkan Passphrase"
                    variant="outlined"
                    onChange={(e) => onChangeState(e.target.name, e.target.value)}
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }}
                    helperText={error.passphrase ? 'Passphrase wajib diisi' : ''}
                />

                {
                    isBypass && bypass && (
                        <Stack>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={state.isBypass}
                                            onChange={(e) => onChangeState('isBypass', e.target.checked)}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: COLORS.primary,
                                                }
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography variant='caption' color={'GrayText'}>
                                            Passphrase akan di encrypt dan di simpan dalam sistem. Aksi selanjutnya tidak perlu menggunakan passphrase lagi
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </Stack>
                    )
                }

                {/* <TextField
                    value={state.komentar}
                    error={error.komentar}
                    fullWidth
                    name='komentar'
                    id="outlined-basic"
                    label="Komentar"
                    variant="outlined"
                    onChange={onChangeState}
                    helperText={error.komentar ? 'Komentar wajib diisi' : ''}
                /> */}
            </Stack>
            <DialogActions>
                <ButtonOutlined variant="outlined" onClick={handleClose}>Batal</ButtonOutlined>
                <ButtonContained variant="contained" onClick={handleSubmit}>Tanda Tangan</ButtonContained>
            </DialogActions>
        </DialogModal>
    )
}

DialogSignDetail.propTypes = {
    state: PropTypes.any,
    error: PropTypes.obj,
    title: PropTypes.string,
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func,
    onChangeState: PropTypes.func,
    open: PropTypes.bool.isRequired,
    bypass: PropTypes.bool
}

export default DialogSignDetail